let e;
function n() {
  return e === void 0 && (e = navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom")), e;
}
export {
  n as isJsdom
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/env/is-jsdom.js
// module id = 1625
// module chunks = 67